<template>
	<div class="City">
		<div class="search-input">
			<form action="/">
			  <van-search
			    v-model="searchKeyWords"
			    placeholder="请输入城市名"
			    show-action
			    @search="onSearch"
			    @cancel="onCancel"
			  />
			</form>
		</div>
		<div class="current-city" v-if="!searchCitysFlag">
			<p>当前城市</p>
			<div class="container">
				<div>
					<van-icon name="location" />
					<span>上海</span>					
				</div>
				<div>
					<van-icon name="replay"/>
					<span>重新定位</span>
				</div>
			</div>
		</div>
		<div class="other-city" v-if="!searchCitysFlag">
			<p>所覆盖城市</p>
			<div class="city-wrap">
			<van-index-bar>
				<template v-for="(item,index) in cityList">
			  		<van-index-anchor :index="index"/>
				  	<van-cell :title="val.name" v-for="(val,ind) in item" :key="ind"/>					
				</template>
				
			</van-index-bar>			
			</div>
		</div>
		<div class="searchCity" v-if="searchCitysFlag">
			<div class="city-item" v-for="(item,index) in searchCityList" :key="index">
					{{item.name}}
			</div>	
		</div>
		
	</div>
</template>
<script>
	import {Citys,CitySearch} from "../../config/interface.js"
	export default{
		data(){
			return{
				searchKeyWords:'',
				searchCityList:[],    //搜索的城市
				cityList:[],     //全国市
				searchCitysFlag:false
			}
		},
		watch:{
			searchKeyWords(newValue,oldValue){
				  if(newValue==''){
				  	this.searchCitysFlag=false;
				  }else{
				  	this.searchCitysFlag=true;
				  	this.searchKeyWords=newValue;
				  	this.onSearch();
				  }
			}
		},
		mounted(){
			this.getAllCitys();
		},
		methods:{
			//搜索
			onSearch(){
				const url=CitySearch;
				let params={
					keywords:this.searchKeyWords
				};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.searchCityList=data;
					}
				})
			},
			//取消
			onCancel(){

			},
			//全国市
			getAllCitys(){
				const url=Citys;
				let params={
					
				};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.cityList=data;
					}
				})
			},
			selectCity(name){

			}
		}
	}
</script>
<style lang="scss">
	.City{
		.search-input{
			i{
				font-size:18px;
			}
		}
		.current-city,.other-city{
			p{
				font-size: 12px;
				color: #999999;
				background: #F1F2F4;
				padding:15px 10px;
			}
		}
		.current-city{
			div.container{
				@include flex(row);
				justify-content:space-between;
				align-items:center;
				padding:20px 15px;
				i{
					font-size:18px;
					color:#901D22;
					margin-right:5px;
				}
				div{
				 @include flex(row);
				 align-items:center;					
				}
			}
		}
		.other-city{
			.van-index-bar__sidebar{
				top:55%;
			}
			.van-index-bar__index{
				line-height: 16px;
			}
			.city-wrap{
				/*padding:0 15px;*/
			}

		}
		.searchCity{
			padding:0 15px;
			.city-item{
				padding:15px 0;
				font-size: 15px;
				color: #999;
				border-bottom:1px solid #dfdfdf;;
			}
		}

	}
</style>


// WEBPACK FOOTER //
// src/pages/Index/city.vue